const ExternalLink = {
  CONTACT: process.env.VUE_APP_URL_CONTACT,
  CAISUKE_POINT: process.env.VUE_APP_URL_CAISUKE_POINT,
  PRIVACY: process.env.VUE_APP_URL_PRIVACY,
  RULE: process.env.VUE_APP_URL_RULE,
  RULE_CAITECH_PHARMACIST: process.env.VUE_APP_URL_RULE_CAITECH_PHARMACIST,
  OCCUPATIONS: process.env.VUE_APP_URL_OCCUPATIONS,
  DOWNLOAD_LINK_FOR_X: process.env.VUE_APP_URL_DOWNLOAD_LINK_FOR_X,
  DOWNLOAD_LINK_FOR_FACEBOOK:
    process.env.VUE_APP_URL_DOWNLOAD_LINK_FOR_FACEBOOK,
  DOWNLOAD_LINK_FOR_LINE: process.env.VUE_APP_URL_DOWNLOAD_LINK_FOR_LINE,
  DOWNLOAD_LINK_FOR_EMAIL: process.env.VUE_APP_URL_DOWNLOAD_LINK_FOR_EMAIL,
  CREDIT_SCORE_IS_ZERO_FAQ_URL: process.env.VUE_APP_CREDIT_SCORE_IS_ZERO_FAQ_URL
} as Record<string, string>;

export default ExternalLink;
